export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7044.98d3c4e8.jpg";